<div class="row">
  <iui-messages  class="mx-auto col-6"></iui-messages>
</div>

<div class="row">
  <div class="offset-1 col-2">
    <h2>Login</h2>
  </div>
</div>
<div class="row">
  <div class="offset-1 col-2">
    Welcome. Please enter your User ID and Password to log in and begin using the Short Code Registry.
  </div>
  <form #loginForm="ngForm" (ngSubmit)="submit()" class="offset-1 col-4">
    <div class="mb-3 ps-5 pe-5 pt-3">
      <label for="userId" class="required" i18n id="userIdLabel">User ID</label>
      <input id="userId" name="userId" required class="form-control" placeholder="User ID" useridvalidator
        [(ngModel)]="loginCredentials.username" #userId="ngModel" [ngClass]="{
                    'error-input':
                      (userId.invalid && loginForm.submitted) ||
                      (userId.invalid && userId.touched)
                  }" autocomplete="username" />
      <app-error-msg [form]="loginForm" [field]="userId" fieldLabel="User ID"></app-error-msg>
      <div *ngIf="!userId.errors?.required && loginForm.submitted &&
                          userId.errors?.useridvalidator" class="col-sm-6" style="padding: 0%">
        <span class="col-sm-6 user-error-box no-float">Spaces not allowed in User ID</span>
      </div>
    </div>
    <div class="mb-3 ps-5 pe-5">
      <label for="password" class="required" i18n id="verificationpassword">Password</label>
      <div class="input-group">
        <input type="password" class="form-control" id="password" name="password" required [ngClass]="{
      'error-input':
        (password.errors?.required && loginForm.submitted) ||
        (password.errors?.required && password.touched)
    }" placeholder="Password" [(ngModel)]="loginCredentials.password" #password="ngModel" #passwordField required
          autocomplete="current-password" [maxlength]="MaxLen.Password"  spellcheck="false"/>
          <span class="input-group-text cursor-pointer" (click)="showPass(passwordField)">
            <i class="fa fa-eye" [ngClass]="{
                          'fa-eye-slash': passwordField.type !== 'password'
                        }"></i>
          </span>
      </div>
      <app-error-msg [form]="loginForm" [field]="password" fieldLabel="Password"></app-error-msg>
    </div>
    <div class="justify-content-center mt-4 d-flex">
      <button id="loginbutton" type="submit" class="btn btn-primary px-4 mb-2">Login</button>
      <app-help-link-icon [helpPath]="'Login'" [customClass]="'ms-1 align-top float-end'"></app-help-link-icon>
    </div>
    <div class="justify-content-center mt-4 d-flex">
      <a [routerLink]="'/sec/forgotpassword'" class="pt-2 link color-blue" i18n id="forgotPWLink">Forgot Password</a>
      <a [routerLink]="'/sec/forgotusername'" class="ms-5 pt-2 link color-blue" i18n id="forgotUsernameLink">Forgot User
        ID</a>
    </div>
    <hr />
    <div class="justify-content-center mt-4 d-flex">
      <a [routerLink]="'/sec/createaccount'" class="mt-2 link color-blue" i18n id="createAccLink">Create an Account</a>
    </div>
  </form>
  <div class="center mt-3">
    <iui-messages  class="ms-auto me-auto"></iui-messages>
  </div>
</div>

<p-dialog i18n-header [closable]="false" [(visible)]="displaySessionExpirationDialog" header="Please sign in again"
  [modal]="true" [style]="{width: '500'}">
  <p i18n>
    You were signed out of your account. Please log in again to continue.
  </p>
  <p-footer>
    <button i18n type="button" id="okbutton" class="btn btn-primary"
      (click)="displaySessionExpirationDialog = false;">OK</button>
  </p-footer>
</p-dialog>


<p-dialog #signedOut header="Please Reset Password" [(visible)]="displayResetPasswordDialog" [modal]="true"
  [style]="{width: '400'}" [closable]="false" [focusOnShow]="false">
  <p i18n>
    The password for your User ID needs to be reset.
  </p>
  <p i18n>
    Please use the "Forgot Password" function to reset your password.
  </p>
  <p-footer>
    <button i18n id="resetPasswordDialogOk" class="btn btn-primary" (click)="redirectToForgotPassword()">OK</button>
  </p-footer>
</p-dialog>